import gql from "graphql-tag";

export const UPDATE_PRODUCT_GROUP = gql`
  mutation updateProductGroup($productGroup: ProductGroupUpdate!) {
    updateProductGroup(input: { productGroup: $productGroup }) {
      productGroup {
        id
        name
        description
        fullPathName
        parentGroup {
          id
          fullPathName
        }
      }
    },
  },
`;
